import * as React from 'react';
import { useState } from 'react';

type ContextType = {
  selectedGlobalSearch?: string;
  setSelectedGlobalSearch: React.Dispatch<React.SetStateAction<string | undefined>>;
  filters?: { id: string; value: any }[];
  setFilters: React.Dispatch<React.SetStateAction<{ id: string; value: any }[]>>;
};

export const IndividualsTableContext = React.createContext<ContextType>({
  selectedGlobalSearch: undefined,
  setSelectedGlobalSearch: () => {},
  filters: [],
  setFilters: () => {},
});

export const IndividualsTableProvider = (props: any) => {
  const [selectedGlobalSearch, setSelectedGlobalSearch] = useState<string | undefined>('');
  const [filters, setFilters] = useState<{ id: string; value: any }[]>([]);

  return (
    <IndividualsTableContext.Provider
      value={{
        selectedGlobalSearch,
        setSelectedGlobalSearch,
        filters,
        setFilters,
      }}
    >
      {props.children}
    </IndividualsTableContext.Provider>
  );
};

export const IndividualsTableConsumer = IndividualsTableContext.Consumer;
